import { useFormikContext } from 'formik';
import { pluck } from '../../helpers/pluck';
import AsyncSelect from "react-select/async";
import { StylesConfig } from 'react-select';

type ComboBoxFormikProps = {
  name: string;
  label?: string;
  loadOptions: (inputValue: string) => Promise<Partial<{ label: string }>[]>;
  className?: string;
  required?: boolean;
  valueProperty?: string;
  value?: string;
};

const inputStyles: StylesConfig<{ label: string, value: string }> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: (style) => ({ ...style, borderColor: '#616161', height: "42px" }) as unknown as any
}

const AutocompleteAsyncFormik: React.FC<ComboBoxFormikProps> = ({ name, label, className, required, loadOptions, valueProperty }) => {
  const { errors, setFieldValue } = useFormikContext();

  return (
    <div className={`h-20 ${className}`}>
      <label htmlFor={name} className="block text-sm font-medium text-gray-600">{label || ''} &nbsp; {required ? <b className="text-redPrimary">*</b> : ' '}</label>
      <AsyncSelect
        onChange={(item) => setFieldValue(name, item || null)}
        cacheOptions
        defaultOptions
        getOptionValue={(item) => valueProperty ? item[valueProperty] : item}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        loadOptions={loadOptions as any}
        styles={inputStyles}
        isClearable={true}
      />

      {pluck(name, errors) ? <small className="text-redPrimary/90" aria-live="polite">{pluck(name, errors)}</small> : null}
    </div>
  );
};


export default AutocompleteAsyncFormik;